<template>
	<v-modal :is-open="isOpen" class="bg-white" @close="close">
		<v-modal-header @close="close">
			{{ content?.content?.title }}
		</v-modal-header>

		<div class="space-y-lg px-lg pb-20">
			<sb-rich-text :document="content?.content?.ingress" />

			<v-avarda v-if="currentLang === 'fi'" :price="priceForCalculator" />

			<!-- eslint-disable max-len -->
			<div v-if="currentLang === 'et'">
				<iframe
					scrolling="no"
					title="Inbank osamakse kalkulaator"
					:src="`https://calculator.inbank.ee/calculator/indivy/plan?amount=${priceForCalculator}&shop_uuid=350b5ed9-8164-4c2c-bc69-39c63632bd7b&product_code=hp_epos_masku_99&currency=eur&lang=et&template=editable_amount&mode=grey&logo=true&show_sample=false&start_session=false&secondary_color=red`"
					width="400"
					height="550"
					frameborder="0"
					class="w-full"
				>
				</iframe>
			</div>
			<!-- eslint-enable max-len -->

			<v-disclosure
				v-for="item in installments"
				:key="item._uid"
				:is-open="item.is_open"
			>
				<template #button>
					<p class="font-bold">{{ item.title }}</p>
				</template>

				<template #content>
					<h-switch-group class="prose space-y-md" as="div">
						<sb-rich-text :document="item.content" />
					</h-switch-group>
				</template>
			</v-disclosure>
		</div>
	</v-modal>
</template>

<script lang="ts" setup>
import {useStoryblokStory} from "@pkg/shared/composables/use-storyblok-story";

const properties = defineProps<{
	price: string;
	isOpen: boolean;
}>();

const emit = defineEmits<{
	(event: "close"): void;
}>();

const {$i18n} = useNuxtApp();

const currentLang = computed(() => $i18n.locale.value);

const priceForCalculator = computed(() =>
	properties.price ? Number(properties.price) : undefined,
);

function close() {
	emit("close");
}

const {data: content} = useStoryblokStory("global/installment-options");

const installments = computed(() => content.value?.content?.installments || []);
</script>
